import Component from '../abstracts/Component';
import ajaxAction from '../utils/ajaxUtil';
import FiltersComponent from './FiltersComponent';
import InfiniteScrollLogic from '../logics/InfiniteScrollLogic';
import {replacePageInHistory} from '../utils/BrowserHistoryUtils';
import TrackingComponent from '../components/TrackingComponent';

export default class PaginationComponent extends Component {
  get SELECTORS() {
    return {
      paginationLink: '[data-page-link]',
      pagination: '[data-pagination]',
      paginationForm: '[data-pager-form]',
      infiniteScrollStartBtn: '.c-l__cta_btn',
      productCard: '.c-product-card',
      productsContainer: '[data-products-container]',
      pageSalesPagination: '[data-sales-pagination]',
      pageSalesPaginationPage: '[data-sales-pagination] a'
    };
  }

  get CLASSES() {
    return {
      salesLinkActive: 'active_link'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.compEl = compEl;
    this.pagination = this.$component.querySelector(this.SELECTORS.pagination);
    this.paginationForm = this.$component.querySelector(this.SELECTORS.paginationForm);
    this.paginationLink = this.$component.querySelectorAll(this.SELECTORS.paginationLink);
    this.infiniteScrollStartBtn = this.$component.querySelector(this.SELECTORS.infiniteScrollStartBtn);
    this.listingArticle = this.$component.querySelectorAll(this.SELECTORS.listingArticle);
    this.productsContainer = document.querySelector(this.SELECTORS.productsContainer);
    this.trackingComponent = new TrackingComponent();
    // ajax
    this.ajaxAction = new ajaxAction();
    this.filterComponent = new FiltersComponent(this.compEl);
    // sales
    this.pageSalesPagination = document.querySelector(this.SELECTORS.pageSalesPagination);
    this.pageSalesPaginationPage = document.querySelectorAll(this.SELECTORS.pageSalesPaginationPage);
  }

  // main function
  paginationHandling(links) {
    // links loop
    links.forEach(link => {
      // adding listener
      link.addEventListener('click', () => {
        // on click i search the desktop id
        let pageId = link.getAttribute('data-page-link');
        if(!link.classList.contains('disabled')) {
          this.changePage(pageId);
        }
      });
    });
  }

  // change page
  changePage(pageId) {
    // get page template
    let tpl = this.pagination.getAttribute('data-page-template');
    // if it is search page and filtered
    if(tpl === 't-search') {
      let fc = new FiltersComponent(this.compEl);
      fc.filterQuery(false, pageId);
    }
  }

  checkPager(dom = false) {
    if(!dom) dom = document;
    // check
    if(this.pagination != null) {
      // get the updated pager and the form
      let updatedPager = dom.querySelector(this.SELECTORS.pagination);
      let updatedPaginationForm = dom.querySelector(this.SELECTORS.paginationForm);
      // if there are pages, let's update in the dom
      if(updatedPaginationForm != null && updatedPaginationForm.querySelectorAll('li').length > 1) {
        // update the html pager
        this.pagination.innerHTML = updatedPager.innerHTML;
        // bind new pager to pagination handling function
        this.paginationHandling(document.querySelectorAll(this.SELECTORS.paginationLink));
        this.pagination.classList.remove('hidden');
        // update form
        if(typeof updatedPaginationForm != 'undefined' && updatedPaginationForm != null) {
          document.querySelector(this.SELECTORS.paginationForm).innerHTML = updatedPaginationForm.innerHTML;
        }
      } else {
        this.pagination.classList.add('hidden');
      }
    }
    // listing part
    if(this.infiniteScrollStartBtn != null) {
      let updatedCards = document.querySelectorAll(this.SELECTORS.productCard);
      let pageSize = dom.querySelector('.js-filters-result').getAttribute('data-page-size');
      if(updatedCards.length < pageSize) {
        this.infiniteScrollStartBtn.classList.add('hidden');
      } else {
        this.infiniteScrollStartBtn.classList.remove('hidden');
      }
    }

  }

  // LISTING PART

  // adding page
  infiniteAddPage(page) {
    // build query with page
    let query = this.filterComponent.buildQuery(page);
    // call new page
    this.ajaxAction.getPage(query).then(newPage => {
      let newURL = query.replace('isRefineSearch=true', 'isRefineSearch=false');
      replacePageInHistory(newURL.replace(/\s.*/, ''), {}, '', true);
      // parse response
      let response = new DOMParser ().parseFromString(newPage, 'text/html');
      // ger prods
      let newProductsLength = response.querySelectorAll('[data-ajax-source="products"] .c-product-card').length;
      let newProducts = response.querySelectorAll('[data-ajax-source="products"] .c-product-card');
      // if i find prod, i put inside the paaaage
      if(newProducts != null) {
        newProducts.forEach(product => {
          document.querySelector(this.SELECTORS.productsContainer).appendChild(product);
        });
        this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.loaded, {newProducts: newProducts});
        this.trackingComponent.actions.loadMore(newProducts);
      }
      this.log(newProductsLength);
      // button
      let newButton = response.querySelector(this.SELECTORS.infiniteScrollStartBtn);
      let actualButton = document.querySelector(this.SELECTORS.infiniteScrollStartBtn);
      if(newButton != null && actualButton != null) {
        actualButton.dataset.page = newButton.getAttribute('data-page');
        actualButton.dataset.infiniteScrollLastpage = newButton.getAttribute('data-infinite-scroll-lastpage');
      }
    });
  }

  // sales part
  salesPaginationHandling(refresh = false) {
    // check
    let paginationLinks = (refresh) ? document.querySelectorAll(this.SELECTORS.pageSalesPaginationPage) : this.pageSalesPaginationPage;
    if (paginationLinks == null) return false;
    // global
    let ctx = this;
    // intercept click
    paginationLinks.forEach(btn => {
      // adding listener
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        // check if active, do nothing
        if (btn.classList.contains(ctx.CLASSES.salesLinkActive)) return false;
        // url to call
        let query = btn.getAttribute('href');
        // call new page
        this.ajaxAction.getPage(query).then(newPage => {
          // parse response
          let response = new DOMParser ().parseFromString(newPage, 'text/html');
          // products
          let newProducts = response.querySelector(this.SELECTORS.productsContainer);
          // render content
          this.ajaxAction.renderContent(newPage,'products');
          // emit events
          this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded);
          this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {
            response: response,
            res: newPage,
            query: query
          });
          // scroll to top
          window.scrollTo(0, 0);
        });

      });
    });
  }

  // MAIN EVENTS
  bindEvents() {
    // dom ready
    $(document).ready(() =>{
      // check pager
      this.checkPager();
    });

    // pager update
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      // check pager
      this.checkPager(payload.response);
      // sales pagination replace html and reset
      if(this.pageSalesPagination != null) {
        let newPagination = payload.response.querySelector(this.SELECTORS.pageSalesPagination);
        if (newPagination != null) {
          this.pageSalesPagination.innerHTML = payload.response.querySelector(this.SELECTORS.pageSalesPagination).innerHTML;
          // refresh pagination
          this.salesPaginationHandling(true);
        } else {
          this.pageSalesPagination.innerHTML = '';
        }
      }
    });
    // view more button
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.next, ({payload}) => {
      this.infiniteAddPage(payload.page);
    });
  }

  // MAIN RENDER
  render() {
    this.log('Rendering...');
    // main events
    this.bindEvents();
    if(this.pagination != null) {
      this.paginationHandling(this.paginationLink);
    }
    // i must check pagination type
    if(this.pageSalesPagination != null) {
      // sales pagination
      this.salesPaginationHandling();
    } else {
      // infinite scroll on PLP
      this.InfiniteScrollLogic = new InfiniteScrollLogic(this);
      this.InfiniteScrollLogic.render();
    }
  }
}
